import React from 'react'
// libs
import styled from 'styled-components'
// hooks
import { useCurrentUser } from 'hooks/useCurrentUser'
// components
import Grid from '@mui/material/Grid2'
import { ReduxEntitySelect, ReduxSwitch } from 'components/FormElements'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// graphql
import { COMPANIES_SELECT_QUERY } from 'graphql/company/queries'
// context
import { TableManagementContext } from 'containers/Search/layers/BL'
// utils
import { companyProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

const Wrapper = styled((props) => <Grid {...props} />)`
  && {
    margin: 0;
    padding: 16px;
    width: inherit;

    & > :last-child {
      margin: 8px 8px 0 auto;
      width: fit-content;
    }
  }
`

interface IIncomingProps {
  clearFilter: () => void
  handleSelectChange: () => void
}

const Filter: React.FC<IIncomingProps> = ({ clearFilter, handleSelectChange }) => {
  const { isAdmin } = useCurrentUser()

  const { handleSetFilter } = React.useContext(TableManagementContext)

  const handleActiveChange = (_event: React.ChangeEvent | undefined, checked: boolean) => {
    handleSetFilter({ active: checked })
  }

  return (
    <Wrapper container spacing={2} direction={'column'} wrap={'nowrap'}>
      {isAdmin &&
        <ReduxEntitySelect
          label={'Account'}
          name={'companyId'}
          onSelectChange={handleSelectChange}
          query={COMPANIES_SELECT_QUERY}
          {...companyProps}
        />
      }
      <ReduxSwitch label='Show Active' name='active' preventInitialChange listenOnChange={handleActiveChange} />
      <Button type={'button'} layout={BUTTON_LAYOUTS.GRAY} onClick={clearFilter}>
        Clear
      </Button>
    </Wrapper>
  )
}

export default Filter
